import type { BrainStatus, ProposalsResponse, PredictionsAccuracyResponse } from '../types';

export function getBrainStatus(): Promise<BrainStatus> {
  return Promise.resolve({
    running: true,
    last_snapshot_at: null,
    last_prediction_at: null,
    pending_proposals_count: 0,
    snapshots_total: 0,
    predictions_total: 0,
    proposals_generated_total: 0,
  });
}

export function getProposals(): Promise<ProposalsResponse> {
  return Promise.resolve({ proposals: [], total: 0, pending: 0 });
}

export function getPredictionsAccuracy(): Promise<PredictionsAccuracyResponse> {
  return Promise.resolve({
    window_days: 7,
    total_outcomes: 0,
    materialized: 0,
    accuracy_pct: 0,
    by_rule: {},
  });
}
